export default __webpack_public_path__ + "tmp_node_modules/photoswipe/dist/photoswipe.css.liquid";